(() => {
  // Keep the anniversary offer accurate even in a tab left open at midnight.
  const switchAt = Date.parse('2026-10-15T00:00:00+01:00');
  const footwearEnds = Date.parse('2026-10-23T00:00:00+01:00');
  const switchKey = 'boles-anniversary-footwear-switch-2026-10-15';
  let reloadAttempted = false;

  const hideExpired = () => {
    document.querySelectorAll('[data-boles-promotion]').forEach(el => el.remove());
    const popup = document.getElementById('boles-anniversary-popup');
    if (popup) {
      if (popup.open && typeof popup.close === 'function') popup.close();
      popup.remove();
    }
  };

  const update = () => {
    const end = Date.parse(document.querySelector('meta[name="boles-promotion-end"]')?.content || '');
    const now = Date.now();

    // A page rendered during menswear cannot switch its Liquid HTML in place.
    // Refresh it once at midnight to render the footwear offer instead.
    if (now >= switchAt && now < footwearEnds && Number.isFinite(end) && end <= switchAt) {
      let previouslyAttempted = reloadAttempted;
      try {
        previouslyAttempted = previouslyAttempted || sessionStorage.getItem(switchKey) === '1';
      } catch (e) {}
      if (!previouslyAttempted) {
        reloadAttempted = true;
        try { sessionStorage.setItem(switchKey, '1'); } catch (e) {}
        window.location.reload();
        return;
      }
      // If a cached page still contains the expired offer, never display it.
      hideExpired();
      return;
    }

    if (!Number.isFinite(end) || now >= end || now >= footwearEnds) hideExpired();
  };

  update();
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  window.setInterval(update, 1000);
})();
